import { Inject, Injectable, OnInit, afterNextRender } from '@angular/core';
import { IWebEngageSdk } from '@core/models/DTOs/webengage-sdk';
import { Interface } from 'readline';

declare var webengage: IWebEngageSdk;

export enum labels {}

@Injectable({
 providedIn: 'root',
})
export class WebengageService {
 labels: any = {
  45: 'iho+',
  36: 'فاصله کوتاه با مترو',
  44: 'اتاق ساعتی',
  33: 'هتل نوساز',
  38: 'هتل بازسازی شده',
 };

 accommodationType: any = {
  1: 'هتل',
  2: 'هتل آپارتمان',
  6: 'خانه، ویلا، سوییت',
  3: 'بومگردی',
  4: 'اقامتگاه',
  5: 'مهمان پذیر',
 };
 constructor() {
  afterNextRender(() => {
   try {
    if (![undefined, null, ''].includes((window as any).webengage))
     webengage.options('proxyURL', 'webengage.iho.co');
   } catch {
   }
  });
 }
 init(apiKey: string): void {}

 track(eventName: string, properties?: Record<string, any>): void {
    if (eventName.toLocaleLowerCase() == 'select filter') {
     try {
     } catch {}
    }
    try {
     if (webengage) webengage.track(eventName, properties);
    } catch {
     return;
    }
 }

 screen(screenName: string, properties?: Record<string, any> | undefined): void {}

 onReady(callback: () => void): void {}

 userIdentify(userId: string, attributes?: Record<string, any> | undefined): void {}

 userLogin(userId: string, attributes?: Record<string, any> | undefined): void {
    try {
     if (webengage) webengage.user.login(userId, attributes);
    } catch {
     return;
    }
 }

 userLogout(): void {
  try {
   if (webengage) webengage.user.logout();
  } catch {
   return;
  }
 }

 userSetAttribute(name: string, value: any): void {
  try {
   if (webengage) webengage.user.setAttribute(name, value);
  } catch {
   return;
  }
 }

 showNotification(message: string): void {}

 hideNotification(): void {}

 showSurvey(surveyId: string): void {}

 hideSurvey(): void {}

 showFeedback(): void {}

 hideFeedback(): void {}

 opennNtificationInbox(): void {}

 closeNotificationInbox(): void {}

 // loadWebEngageScript() {
 //   script.src = 'apps/ihowebsite/src/app/webengage-sdk.js';
 //   script.id = '_webengage_script_tag';
 //   script.type = 'text/javascript';
 //   document.head.appendChild(script);
 // }

 // createAttributes(type: Interface): Record<string, any> {}
}
